// Persistent "finish setup" nudge for a parish without a working MSP
// connection — the degraded state a coordinator lands in after
// choosing "Skip for now" on the signup wizard's connect step.
//
// Renders only on an explicit msp_connected === false from the authed
// settings payload: undefined means an older worker or the public
// branding payload, and neither should nag. Deliberately not
// dismissible — the product doesn't work without MSP, so this is a
// setup task, not an announcement.

import { Link, useLocation } from "react-router-dom";
import { useParish } from "../lib/parishContext";

export default function ConnectMspBanner() {
  const { parish } = useParish();
  const location = useLocation();

  if (parish.msp_connected !== false) return null;
  // The print roster is a chrome-less surface; keep it that way.
  if (location.pathname.startsWith("/holy-week/print")) return null;

  return (
    <aside className="app-banner">
      <span>
        <strong>Almost there.</strong> Connect Ministry Scheduler Pro so Sacristy AI can read
        your schedule.
      </span>
      <Link className="app-banner__link" to="/signup">
        Connect MSP
      </Link>
    </aside>
  );
}
